import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import styles from './ClinicMaterialsForms.module.scss';
import DashboardTableCard from '../components/DashboardTableCard';
import { Breadcrumb, Row, Col } from 'react-bootstrap';
import Loader from '../components/Loader';
import { BsTrash, BsEye } from 'react-icons/bs';
import { alertModal, confirmModal } from '../utils/modalController';
import { Link } from 'react-router-dom';
import { fetchAuth } from '../utils/fetchAuth';

const apiUrl = process.env.REACT_APP_API_URL || '';
const TrashIcon = BsTrash as React.FC<{ size?: number; color?: string }>;
const ShowIcon = BsEye as React.FC<{ size?: number; color?: string }>;

const ClinicMaterialsForms: React.FC = () => {

    const [forms, setForms] = useState<Form[]>([]);
    const [loading, setLoading] = useState(true);
    const [isTooSmall, setIsTooSmall] = useState(window.innerWidth < 770);

    useEffect(() => {
        const handleResize = () => {
            setIsTooSmall(window.innerWidth < 770);
        };

        window.addEventListener('resize', handleResize);

        // limpa o listener ao desmontar
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        fetchAuth(apiUrl + '/consultorio/forms') 
            .then(async (response) => {
                if (!response.ok) {
                    const errorText = await response.text();
                    throw new Error(`Erro na resposta da API: ${response.status} - ${errorText}`);
                }
                return response.json();
            })
            .then((json) => {
                setForms(json);
            })
            .catch((err) => {
                console.error('Erro ao buscar forms:', err);
                alertModal('Erro ao buscar forms: ' + err);
                setForms([]); // fallback
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    if (loading) return <Loader />;

    return (
        <Container className="center">
            <h2 className={styles["title"]}>Consultório</h2>
            <Row className={styles["row-breadcrumb"]}>
                <Col>
                    <Breadcrumb className={styles.breadcrumb}>
                        <Breadcrumb.Item linkAs={Link} linkProps={{to:"/consultorio"}}>Consultório</Breadcrumb.Item>
                        <Breadcrumb.Item active>Formulários</Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
            </Row>
            <DashboardTableCard
                welcomeMessage={`Formulários`}
                tableData={{
                    headings: ['Título', 'Ações'],
                    data: [
                        ...(isTooSmall ? [] : [
                            [
                                <Link to="/consultorio/formularios/new" className={styles["link"]}>
                                    Novo Formulário
                                </Link>
                            ]
                        ]),
                        ...forms.map((form) => [
                            !isTooSmall ? (<Link to={`/consultorio/formularios/${form.id}`} className={styles["link"]}>
                                {form.title}
                            </Link>) : (<>{form.title}</>),
                            <>
                                <Link to={`/formularios/${form.id}?preview=true`} className={styles["link"]} >
                                    <ShowIcon />
                                </Link>
                                <a href='#' className={styles["link"]} onClick={async (e) => {
                                    e.preventDefault();
                                    if (!await confirmModal('Tem certeza que deseja excluir este formulário? Esta ação não pode ser desfeita.')) return;

                                    try {
                                        const response = await fetchAuth(`${apiUrl}/consultorio/forms/${form.id}`, {
                                            method: 'DELETE',
                                        });
                                        if (!response.ok) {
                                            const errorText = await response.text();
                                            throw new Error(`Erro na resposta da API: ${response.status} - ${errorText}`);
                                        }
                                        const json = await response.json();
                                        setForms(forms.filter(f => f.id !== form.id));
                                    } catch (err) {
                                        console.error('Erro ao excluir formulário:', err);
                                        alertModal('Erro ao excluir formulário: ' + err);
                                    } finally {
                                    }
                                }}>
                                    <TrashIcon />
                                </a>
                            </>
                        ])
                    ]

                }}
            />
        </Container>
    );
};

export default ClinicMaterialsForms;
